document.addEventListener("DOMContentLoaded", function () {
    let t = [
        { productId: 47611922808995, quantity: 1 },
        { productId: 47611922907299, quantity: 1 },
        { productId: 47611922940067, quantity: 1 },
    ];
    function o() {
        return fetch("/cart.js")
            .then((t) => t.json())
            .then((t) => t.items)
            .catch((t) => (console.error("Error fetching cart contents:", t), []));
    }
    jQuery(document).on("click", ".custom-product", function () {
        setTimeout(() => {
            o().then((o) => {
                let r = o.map((t) => t.id);
                console.log("\uD83D\uDED2 Cart contains:", r);
                let d = Promise.resolve();
                t.forEach((t) => {
                    r.includes(t.productId)
                        ? console.log(`✅ Addon ${t.productId} already in cart.`)
                        : (console.log(`➕ Adding addon ${t.productId}...`),
                          (d = d.then(() => {
                              var o, r;
                              return (
                                  (o = t.productId),
                                  (r = t.quantity),
                                  fetch("/cart/add.js", {
                                      method: "POST",
                                      headers: { "Content-Type": "application/json" },
                                      body: JSON.stringify({ id: o, quantity: r }),
                                  })
                                      .then((t) =>
                                          t.ok
                                              ? t.json()
                                              : t.text().then((t) => {
                                                    throw Error(t);
                                                })
                                      )
                                      .then((t) => console.log(`✅ Added product ${o} to cart.`))
                                      .catch((t) => console.error("❌ Error adding product:", t))
                              );
                          })));
                }),
                    jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data"),
                    d.then(() => {
                        jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").load(
                            "/cart?view=ajax_side_cart",
                            function () {
                                console.log("✅ All add-ons added. Cart refreshed."),
                                    jQuery(".previewCart").css({ "overflow-y": "auto", "overflow-x": "hidden" });
                            }
                        );
                    });
            });
        }, 1e3);
    }),
        jQuery(document).on("click", ".previewCartItem-remove", function () {
            setTimeout(() => {
                o().then((o) => {
                    let r = o.map((t) => t.id),
                        d = r.includes(8670841831649),
                        e = t.map((t) => t.productId),
                        n = o.filter((t) => e.includes(t.id)).length;
                    !d && n > 0
                        ? (console.log("⚠️ Main product removed. Removing add-ons..."),
                          t.forEach((t) => {
                              var o;
                              fetch("/cart/change.js", {
                                  method: "POST",
                                  headers: { "Content-Type": "application/json" },
                                  body: JSON.stringify({ id: (o = t.productId), quantity: 0 }),
                              })
                                  .then((t) => t.json())
                                  .then((t) => console.log(`❌ Removed product ${o} from cart.`))
                                  .catch((t) => console.error("❌ Error removing product:", t));
                          }))
                        : console.log("✅ Main product in cart or no addons to remove.");
                });
            }, 500);
        });
});
